import { render } from "./age-filter.vue?vue&type=template&id=28872e30&scoped=true&lang=pug"
import script from "./age-filter.vue?vue&type=script&lang=js"
export * from "./age-filter.vue?vue&type=script&lang=js"

import "./age-filter.vue?vue&type=style&index=0&id=28872e30&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28872e30"]])

export default __exports__